import { Component, OnInit, Input, inject } from "@angular/core";

import { ApiService } from "src/app/api.service";
import { DatetimePipe } from "src/app/pipes";
import { APIResults } from "src/app/sharedinterfaces";

@Component({
	selector: "app-mech-firmware",
	templateUrl: "./mech-firmware.component.html",
	styleUrls: ["./mech-firmware.component.scss"],
	imports: [DatetimePipe]
})
export class MechFirmwareComponent implements OnInit {
	api = inject(ApiService);

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	components: APIResults.AssetComponentList;

	public devices: APIResults.FirmwareStatus[];
	public optime: Date;

	async ngOnInit() {
		await this.updateFirmware();
	}

	async updateFirmware() {
		const result = await this.api.GetFirmware(this.asset.asset_id);
		this.devices = result.devices;
		this.optime = result.ts;
	}
}
